export default __webpack_public_path__ + "static/media/delete.f6b2c2a6.svg";